module.exports = __webpack_public_path__ + "static/media/imd_logo_2023.f6e2b266.png";